import React from "react";

import styles from "./ContentCard.module.scss";

interface Props {
  title: string;
  titleEn: string;
  iconSrc: string;
}

class ContentCard extends React.PureComponent<Props> {
  public render() {
    const {
      title,
      titleEn,
      // TODO: Fix src of icon
      iconSrc,
    } = this.props;
    return (
      <div className={styles.card}>
        <div className={styles.content}>
          <div className={styles.iconContainer}>
            <img className={styles.icon} src={iconSrc} />
          </div>
          <p className={styles.titleJa}>{title}</p>
          <p className={styles.titleEn}>{titleEn}</p>
        </div>
      </div>
    );
  }
}

export { ContentCard };
